import React from 'react';
import { CheckCircle, Loader, AlertCircle } from 'lucide-react';

const ProgressBar = ({ 
  percentage = 0, 
  status = 'processing',
  showIcon = true,
  showLabel = true,
  size = 'md'
}) => {
  const getStatusColor = () => {
    if (status === 'completed' || percentage >= 100) return 'bg-green-500';
    if (status === 'failed') return 'bg-red-500';
    if (status === 'transcribing') return 'bg-blue-500';
    if (status === 'ai_analyzing') return 'bg-purple-500';
    return 'bg-blue-600';
  };

  const getStatusIcon = () => {
    if (percentage >= 100 || status === 'completed') return <CheckCircle className="w-4 h-4 text-green-500" />;
    if (status === 'failed') return <AlertCircle className="w-4 h-4 text-red-500" />;
    return <Loader className="w-4 h-4 text-blue-600 animate-spin" />;
  };

  const getStatusText = () => {
    if (status === 'queued') return 'Queued...';
    if (status === 'transcribing') return 'Transcribing audio...';
    if (status === 'transcribing_completed') return 'Transcription complete!';
    if (status === 'thumbnail_extracting') return 'Extracting thumbnail...';
    if (status === 'thumbnail_completed') return 'Thumbnail extracted!';
    if (status === 'ai_analyzing') return 'AI analyzing...';
    if (status === 'ai_completed') return 'AI analysis complete!';
    if (status === 'completed') return 'Processing complete!';
    if (status === 'failed') return 'Processing failed';
    return 'Processing content...';
  };

  const heightClass = size === 'sm' ? 'h-1.5' : size === 'lg' ? 'h-3' : 'h-2';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div className="w-full">
      {/* Progress Bar */}
      <div className="relative">
        <div className={`w-full ${heightClass} bg-gray-200 rounded-full overflow-hidden`}>
          <div
            className={`${getStatusColor()} h-full transition-all duration-500 ease-out rounded-full`}
            style={{ width: `${Math.min(Math.max(percentage, 0), 100)}%` }}
          />
        </div>
      </div>

      {/* Status Info */}
      {showLabel && (
        <div className="flex items-center justify-between mt-1">
          <div className="flex items-center space-x-2">
            {showIcon && getStatusIcon()}
            <span className={`text-gray-600 ${textSize}`}>
              {getStatusText()}
            </span>
          </div>
          <span className={`font-medium ${getStatusColor().replace('bg-', 'text-')} ${textSize}`}>
            {percentage}%
          </span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;

